import { jsx as _jsx } from "react/jsx-runtime";
import { Badge } from '~/components/shadcn/badge';
const StatusCellRenderer = ({ value }) => {
    if (!value)
        return null;
    const getStatusConfig = (status) => {
        switch (status.toLowerCase()) {
            case 'active':
                return {
                    variant: 'outline',
                    className: 'bg-green-100 text-green-800 border-green-200'
                };
            case 'inactive':
                return {
                    variant: 'destructive',
                    className: 'bg-red-100 text-red-800 border-red-200'
                };
            case 'pending':
                return {
                    variant: 'secondary',
                    className: 'bg-yellow-100 text-yellow-800 border-yellow-200'
                };
            default:
                return {
                    variant: 'secondary',
                    className: 'bg-gray-100 text-gray-800 border-gray-200'
                };
        }
    };
    const config = getStatusConfig(value);
    return (_jsx(Badge, { variant: config.variant, className: config.className, children: value.toUpperCase() }));
};
export default StatusCellRenderer;
